import config from '../../config.json'
import React from 'react';
import { ReviewLAClaims, EditLAClaims, ShowLAName, ValidateLAClaims } from './LearningAcademy/learningAcademy';
import { EditMedBankClaims, ReviewMedBankClaims, ShowMedBankName, ValidateMedbankClaims } from './Medbank/medbank';
import { EditLCClaims, ReviewLCClaims, ShowLCName, ValidateLCClaims } from './LearningCompass/LearningCompass';
export interface Registry {
    [appName: string]: React.FC
};

export interface FunctionRegistry {
    [appName: string]: (data: any) => [boolean, Map<string, boolean>]
};

//@ts-ignore
const CONFIG = config[process.env.NODE_ENV];
const appComponentRegistry: Registry = {};
const appNameDisplayRegistry: Registry = {};
const appConfirmDetailsRegistry: Registry = {};
const appValidateDetailsRegistry: FunctionRegistry = {};

export function registerApp(appName: string, editComponent: React.FC, nameDisplay: React.FC, confirmDetails: React.FC, validateDetails: (data: any) => [boolean, Map<string, boolean>]) {
    appComponentRegistry[appName] = editComponent;
    appNameDisplayRegistry[appName] = nameDisplay;
    appConfirmDetailsRegistry[appName] = confirmDetails;
    appValidateDetailsRegistry[appName] = validateDetails;
}

function getAppName(appId: string | null) {
    for (const key of Object.keys(CONFIG)) {
        //@ts-ignore
        if (CONFIG[key] === appId) {
            return key
        }
    }
    return "";
}

export function isAppDataValid(appId: string | null, data: any, setValidationFlags: (err: Map<string, boolean>) => void): boolean {
  const name = getAppName(appId);
  if (name === '') return true;

  try {
    let [isValid, validationFlags] = appValidateDetailsRegistry[name](data);
    //console.log("is valid from appValidateDetailsRegistry "+ isValid)
    //console.log("validation Flags "+validationFlags);
    setValidationFlags(validationFlags);
    return isValid;
  } catch {
    console.error(`Validation logic for app with name ${name} not found`);
    return true;
  }
}

export function doesAppRequireAdditionalClaims(appId: string | null) {
    if (appId === null) return false;
    return getAppName(appId) !== "";
}

export function getAppComponent(  props: any,  goBack: null | (() => void),  goForward: null | (() => void)): [React.ReactElement | null, boolean] {
  const appId = props.appId;
  const name = getAppName(appId);

  //console.log('index props: ' + JSON.stringify(props));
  var dontDisplayBDLA = false;
  if (props != null) {

    if(appId == CONFIG.learningAcademyLevel2 || appId== CONFIG.learningAcademyLevel3) {
      //console.log('app is level 2 and level 2');
      if (props["global"] != null) {
        if (props["global"]["LA_role"] != null && props["global"]["LA_care_setting"] != null) {
          dontDisplayBDLA = true;
        }
      }
    }

  }

  if (name === "" || props.skipBDLAStep || dontDisplayBDLA) {
    //console.log("props.skipBDLAStep.: " + props.skipBDLAStep);
    //console.log("dontDisplayBDLA.: " + dontDisplayBDLA);
    return [<></>, false];
  }

  const AppComponent = appComponentRegistry[name];

  if (!AppComponent) {
    console.error(`App with name ${name} not found`);
    return [<></>, false];
  }

  //Use JSX to render the component properly
  return [
    <>
      <AppComponent {...props} />
      <div className="spacer"></div>
      <p className="buttons align-right">
        {goForward && (
          <button
            id="continue"
            className="button 394b58c5-ee63-4444-978a-c0373030b4f2"
            onClick={goForward}
          >
            Continue
          </button>
        )}
        {goBack && (
          <button
            className="gray button 041b8acf-fafc-450f-8111-d7d0c36bba6b"
            onClick={goBack}
          >
            Back
          </button>
        )}
      </p>
    </>,
    true,
  ];
}

export function getProfileEditDisplay(props: any): [React.ReactElement | null, boolean] {
    // For now we just want to return the psame component for profile edit, if in the future we want different styling or behavior that extension can go here
    return getAppComponent(props, null, null);
}

export function getNameDisplay(props: any): [JSX.Element, boolean] {    
    const appId = props.appId;
    const name = getAppName(appId);
      
    if (name === "learningCompass" && appId === "https:bdsandbox.litmos.com") {
        //console.log("skip the customeApp registration step for ",name); //Remove pp from mybd learning
        return [<></>, false];
    }
    else if (name === "") {        
        return [<></>, false];
    }
    else if (props.skipBDLAStep) {        
        //console.log("skip the BDLA step ",name);
        return [<></>, false];
    }
    try {
        
        let nameDisplay = appNameDisplayRegistry[name](props);        
        if(nameDisplay)
            return [nameDisplay, true];
        else
            return [<></>, false]
    } catch {
        console.error(`App with name ${name} not found`);
        return [<></>, false];
    }
}


export function getConfirmDetailsDisplay(props: any): [React.ReactElement | null, boolean] {
    const appId = props.appId;
    const name = getAppName(appId);
    if (name === "") {
        return [<></>, false];
    }
    try {
        return [appConfirmDetailsRegistry[name](props), true];
    } catch {
        console.error(`App with name ${name} not found`);
        return [<></>, false];
    }
}

registerApp(
    'learningAcademy',
    EditLAClaims,
    ShowLAName,
    ReviewLAClaims,
    ValidateLAClaims
);

registerApp(
    'MedBank',
    EditMedBankClaims, 
    ShowMedBankName, 
    ReviewMedBankClaims, 
    ValidateMedbankClaims
);

registerApp(
    'learningAcademyLevel2',
    EditLAClaims,
    ShowLAName,
    ReviewLAClaims,
    ValidateLAClaims
);
registerApp(
    'learningAcademyLevel3',
    EditLAClaims,
    ShowLAName,
    ReviewLAClaims,
    ValidateLAClaims
);

/*registerApp(
    'learningCompass',
    EditLCClaims, /* this is creating the brands checklist 
    ShowLCName, 
    ReviewLCClaims, 
    ValidateLCClaims
);*/